import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import { useParams } from 'react-router-dom';
import { ButtonBoxWrapper, Chart } from './style';
import { CTA, Text } from '../../../atoms';
import { registrationIsAllowed, sessionIsLive } from '../../../../utils/events';
import {
  JOIN_BBB_SESSION,
  RESET_BBB_SESISON,
  SESSION_REGISTRATION_SET,
} from '../../../../app/redux/actions/events';
import DoughnutChart from '../../DoughnutChart';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import CustomTooltip from '../../../atoms/CustomTooltip';
import { hasPermission } from '../../../../utils/permissions';
import { USERS_ATTENDANCE_SET } from '../../../../app/redux/actions/liveEvent';

const options = {
  cutout: '75%',
  rotation: 0,
};

const ButtonBox = ({
  mediaIsPhone,
  activity,
  sessionId,
  info,
  uid,
  permissions,
  setRegistration,
  joinBBBSession,
  bbbSession,
  resetSessionBBB,
  setUserAttendance,
}) => {
  const { course_id } = useParams();
  const { registration = {}, url, meeting_id, address } = activity || {};
  const [today, setToday] = useState(0);

  useEffect(() => {
    setToday(dayjs().unix());
  }, []);

  useEffect(() => {
    if (bbbSession) {
      window.open(bbbSession, '_blank');
      resetSessionBBB();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bbbSession]);

  const onClickJoin = (act = {}) => {
    if (act?.attendance === 'without_attendance') {
      setUserAttendance({
        session_id: sessionId,
        activity_id: act?.id,
        body: {
          add_users: [uid],
          remove_users: [],
        },
      });
    }
    if (act?.url) window.open(act.url, '_blank');
    else joinBBBSession(activity?.id);
  };

  // activity ended
  if (info?.tsEnd < today) {
    return (
      <ButtonBoxWrapper>
        <Text type="h3">Sessione terminata</Text>
      </ButtonBoxWrapper>
    );
  }
  // free activity
  if (activity?.access_type === 'free_access') {
    return (
      <ButtonBoxWrapper>
        <Text type="h3" mb={16}>
          Accesso libero
        </Text>
        {activity?.url || activity?.type === 'activity_session_virtual_room' ? (
          <>
            <Text type="b3" mb={40} className="text-center">
              Il pulsante “Partecipa” si attiverà in prossimità dell’inizio
              della sessione.
            </Text>
            <CTA
              btnText="Partecipa"
              disabled={!info?.isLive}
              onClick={() => onClickJoin(activity)}
              fullsize={mediaIsPhone}
            />
          </>
        ) : (
          <Text type="b3" className="text-center">
            Recati sul posto all'orario indicato
          </Text>
        )}
      </ButtonBoxWrapper>
    );
  }
  // activity with registration
  const {
    is_registered,
    available_places = 0,
    registered_number = 0,
  } = activity;

  return (
    <ButtonBoxWrapper>
      <div className="d-flex align-start">
        <Text type="h3" mb={16}>
          Posti disponibili:
        </Text>
        <CustomTooltip
          title="Partecipazione alla sessione"
          tooltipKey="session_participation"
          type="secondary"
        />
      </div>
      <Chart>
        <DoughnutChart
          config={{
            labels: ['Posti disponibili', 'Posti occupati'],
            datasets: [
              {
                data: [available_places - registered_number, registered_number],
                backgroundColor: ['#009CF7', 'white'],
                borderWidth: 1,
                borderRadius: 6,
              },
            ],
          }}
          customOptions={options}
        />
        <Text type="h2" className="registration">
          {available_places - registered_number}
          <span className="max-number">/{available_places}</span>
        </Text>
      </Chart>
      {today <= info?.tsStart && !hasPermission(permissions, 'tutoring') ? (
        <div className="btn-wrapper">
          {registered_number >= available_places ? (
            <Text type="b3">Non ci sono posti disponibili</Text>
          ) : is_registered ? (
            <Text type="b3">Attendi che l'evento abbia inizio</Text>
          ) : (
            <CTA
              btnText="Registrati"
              disabled={!registrationIsAllowed(registration)}
              fullsize={mediaIsPhone}
              onClick={() =>
                setRegistration({
                  sessionId,
                  activityId: activity?.id,
                  eventId: course_id,
                })
              }
            />
          )}
        </div>
      ) : url || (activity?.type === 'online_bbb' && meeting_id) ? (
        <div className="btn-wrapper">
          <CTA
            btnText="Partecipa"
            disabled={
              !sessionIsLive(activity) ||
              // if has tutoring permission check if is registered
              (!hasPermission(permissions, 'tutoring') && !is_registered)
            }
            onClick={() => onClickJoin(activity)}
            fullsize={mediaIsPhone}
          />
        </div>
      ) : is_registered && address ? (
        <Text type="b3" className="text-center">
          Recati sul posto all'orario indicato
        </Text>
      ) : (
        <div className="btn-wrapper">
          <Text type="b3">Registrazioni chiuse per questa sessione</Text>
        </div>
      )}
    </ButtonBoxWrapper>
  );
};

ButtonBox.propTypes = {
  mediaIsPhone: PropTypes.bool,
  activity: PropTypes.object,
  info: PropTypes.object,
  sessionId: PropTypes.number,
  // HOC: state
  uid: PropTypes.number,
  bbbSession: PropTypes.string,
  permissions: PropTypes.array,
  // HOC: dispatch
  setRegistration: PropTypes.func,
  joinBBBSession: PropTypes.func,
  resetSessionBBB: PropTypes.func,
  setUserAttendance: PropTypes.func,
};

export default connect(
  (state) => {
    const { uid } = state.user;
    const { link: bbbSession } = state.events.bbb;
    const { events: permissions } = state.permissions;
    return { uid, bbbSession, permissions };
  },
  (dispatch) => ({
    setRegistration: ({ sessionId, activityId, eventId }) =>
      dispatch({
        type: SESSION_REGISTRATION_SET._REQUEST,
        sessionId,
        activityId,
        eventId,
      }),
    joinBBBSession: (id) => dispatch({ type: JOIN_BBB_SESSION._REQUEST, id }),
    resetSessionBBB: () => dispatch({ type: RESET_BBB_SESISON }),
    setUserAttendance: ({ session_id, activity_id, body }) =>
      dispatch({
        type: USERS_ATTENDANCE_SET._REQUEST,
        session_id,
        activity_id,
        body,
      }),
  })
)(withMediaQueries(ButtonBox));
